import { CKEditor5 } from '../components/ckeditor';

export declare class PluginDecoratorModel {
  pluginDecorator: TemplateTypeModel[];
  enablePlugin: PluginModel[];
  toggleTemplateDocHoverUI: string;
  enableInlineTrackChanges: EnableInlineTrackChangesModel[];
}

export interface EnableInlineTrackChangesModel {
  name: string;
  isEnabled: boolean;
  toggleMode: string;
}

export interface TemplateTypeModel {
  type: string;
  attributes: TagAttributesModel[];
}

export declare class TagAttributesModel {
  name: string;
  value?: string;
  format?: string;
}

export interface CitationDecoratorModel {
  [key: string]: string;
}

export interface PluginModel {
  name: string;
  value: boolean;
}

export declare class EnablePluginModel {
  enablePlugin?: PluginModel;
}

export interface ActiveMarkerInterface {
  data: string;
  editor: CKEditor5.Editor;
  event: CKEditor5.EventInfo<'activemarker'>;
}
